import { API_ENDPOINT } from "@/constants/appConstants";
import { getHttpMethod } from "@/helpers/getHttpMethod";
import { useProfileSectionData } from "@/hooks";
import { PROFILE_QUERY_KEY, PROFILE_STATS_QUERY_KEY } from "@/lib/queryKeys";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { ActionType, ErrorResponse } from "@/components/profile/types";

import { SocialPresenceApiType, WorkSampleApiType } from "./types";

// export const getSocialLinks = (): UseQueryResult<
//   SocialPresenceApiType,
//   Error
// > => {
//   return useQuery({
//     queryKey: [SOCIAL_PRESENCE_QUERY_KEY],
//     queryFn: () => profileAPI<SocialPresenceApiType>("social_presence"),
//   });
// };

export const getSocialLinks = () => {
  return useProfileSectionData<SocialPresenceApiType>("socialPresenceSection");
};

export const useSocialLinks = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      data,
      action = "add",
    }: {
      data: any;
      action: ActionType;
    }) => {
      const method = getHttpMethod(action);
      const response = await fetch(
        API_ENDPOINT(window.location.host).middleware.socialPresence,
        {
          method,
          body: JSON.stringify(data),
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",
        },
      );

      if (!response.ok) {
        const errorData = (await response.json()) as ErrorResponse;
        throw new Error(
          errorData.error.message.errorMessage || "Something went wrong",
        );
      }

      return await response.json();
    },
    onSuccess: (data, variables) => {
      if (
        variables &&
        Array.isArray(variables?.data) &&
        variables?.data[0]?.url &&
        variables.data[0].url.includes("linkedin")
      ) {
        // for updating the profile score
        queryClient.invalidateQueries({ queryKey: [PROFILE_STATS_QUERY_KEY] });
      }
      queryClient.invalidateQueries({
        queryKey: [PROFILE_QUERY_KEY],
      });
      // queryClient.invalidateQueries({
      //   queryKey: [SOCIAL_PRESENCE_QUERY_KEY],
      // });
    },
  });
};

// export const getWorkSmapleLinks = (): UseQueryResult<
//   WorkSampleApiType,
//   Error
// > => {
//   return useQuery({
//     queryKey: [WORK_SAMPLE_QUERY_KEY],
//     queryFn: () => profileAPI<WorkSampleApiType>("work_sample"),
//   });
// };

export const getWorkSmapleLinks = () => {
  return useProfileSectionData<WorkSampleApiType>("workSampleSection");
};

export const useWorkSampleLinks = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      data,
      action = "add",
    }: {
      data: any;
      action: ActionType;
    }) => {
      const method = getHttpMethod(action);
      const response = await fetch(
        API_ENDPOINT(window.location.host).middleware.workSample,
        {
          method,
          body: JSON.stringify(data),
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",
        },
      );

      if (!response.ok) {
        const errorData = (await response.json()) as ErrorResponse;
        throw new Error(
          errorData.error.message.errorMessage || "Something went wrong",
        );
      }

      return await response.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [PROFILE_QUERY_KEY] });
      // queryClient.invalidateQueries({ queryKey: [WORK_SAMPLE_QUERY_KEY] });
    },
  });
};
